import { createSlice } from "@reduxjs/toolkit";
import { BlogDefaultDataset } from "../data_model/blogModel/blog_model";

export const update_Blog_Post = createSlice({
  name: "update_Blogs",
  initialState: {
    value: {
      status: false,
      langMap: {},
      defaultLangMap: [BlogDefaultDataset],
    },
  },
  reducers: {
    //create first data item
    updateAllData: (state, action) => {
      state.value.status = true;
      state.value.langMap = action.payload;
    },
    //add empty language dataset
    addNewLangData: (state, action) => {
      state.value.status = true;
      const incomingPayload = action.payload;
      const newArray = [...state.value.langMap.langMap, incomingPayload];
      state.value.langMap.langMap = newArray;
    },
    //update individual items in localization array
    replaceIndex: (state, action) => {
      state.value.status = true;
      const newPayload = action.payload;
      const existingPayload = state.value.langMap.langMap;
      const newUpdateData = existingPayload.map((item) =>
        item.langCode === newPayload.langCode ? newPayload : item
      );
      state.value.langMap.langMap = newUpdateData;
    },
  },
});

export const { updateAllData, addNewLangData, replaceIndex } =
  update_Blog_Post.actions;

export default update_Blog_Post.reducer;
